export default "__VITE_ASSET__84084979__"